import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { Substructure } from "../../../../http/deckDesigner/types/substructures";
import useDeckSubstructuresApi from "../../../../http/deckDesigner/useSubstructures";
import SubstructureForm from "./SubstructureForm";

const AdminSubstructures: FC = () => {
  const i18n = useI18n();
  const substructuresApi = useDeckSubstructuresApi();
  const unitMm = i18n.translation.common.unitMm;

  return (
    <AdminCrudTable<Substructure>
      filterPrefix="substructures"
      useList={substructuresApi.useDeckSubstructures}
      head={
        <>
          <TableHeadCell align="left">{i18n.translation.common.code}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureMaterials.singular}
          </TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructureFamilies.singular}
          </TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.deckDesignerModule.substructures.base}</TableHeadCell>
          <TableHeadCell align="left">{i18n.translation.common.height}</TableHeadCell>
          <TableHeadCell align="left">
            {i18n.translation.deckDesignerModule.substructures.secondMomentOfArea}
          </TableHeadCell>
        </>
      }
      renderRow={(item) => (
        <>
          <TableCell>{item.item?.code}</TableCell>
          <TableCell>{item.substructureMaterials.map((m) => m.name).join(", ")}</TableCell>
          <TableCell>{item.substructureFamily?.name}</TableCell>
          <TableCell>{item.base != null && `${item.base} ${unitMm}`}</TableCell>
          <TableCell>{item.height != null && `${item.height} ${unitMm}`}</TableCell>
          <TableCell>
            {item.secondMomentOfArea != null && `${item.secondMomentOfArea} ${i18n.translation.common.unitM4}`}
          </TableCell>
        </>
      )}
      visibilityAndOrder={{
        updateVisibility: (item, visibility) =>
          substructuresApi.updateDeckSubstructureVisibility(item.id, { visibility }),
        updateOrder: (item, order) => substructuresApi.updateDeckSubstructureOrder(item.id, { order }),
      }}
      onDelete={(item) => substructuresApi.deleteDeckSubstructure(item.id)}
      deleteTitle={i18n.translation.deckDesignerModule.substructures.singular}
      canAdd
      renderForm={(item, onClose) => <SubstructureForm substructure={item} onClose={onClose} />}
    />
  );
};

export default AdminSubstructures;
